module["exports"] = {
  "adjective": [
    "صغير",
    "مريح",
    "ريفي",
    "ذكي",
    "رائع",
    "لا يصدق",
    "عملي",
    "أملس",
    "ممتاز",
    "عام",
    "يدويا",
    "صنع يدوي",
    "مرخص",
    "مشتق",
    "بدون علامة",
    "طيب المذاق"
  ],
  "material": [
    "فولاذ",
    "خشبي",
    "خرسانة",
    "بلاستيك",
    "قطن",
    "صوان",
    "مطاط",
    "معدن",
    "ناعم",
    "طازج",
    "مجمد"
  ],
  "product": [
    "كرسي",
    "سيارة",
    "حاسوب",
    "لوحة المفاتيح",
    "فأر",
    "دراجة هوائية",
    "كرة",
    "قفازات",
    "بنطال",
    "قميص",
    "طاولة",
    "أحذية",
    "قبعة",
    "مناشف",
    "صابون",
    "تونة",
    "دجاج",
    "سمك",
    "جبن",
    "لحم خنزير مقدد",
    "بيتزا",
    "سلطة",
    "سجق",
    "رقائق بطاطس"
  ]
};
